import { cx } from 'class-variance-authority';
import { useFormContext } from 'react-hook-form';

import type { SchemaBlockStyleType } from '@/utils/schema/schemas';

import { InputCheckForm } from '../../../../views/Admin/components/Inputs/InputCheck';
import InputFormContext from '../../../../views/Admin/components/Inputs/InputFormContext';
import InputSelectContext from '../../../../views/Admin/components/Inputs/InputSelectContext';
import TitleSection from '../../../../views/Admin/private/FooterGovCo/components/TitleSection';

// Interfaz para las opciones de color
interface ColorOption {
  label: string;
  value: string;
}

// Enum para los valores de color
export enum BlockColor {
  SYSTEM = 'system',
  WHITE = 'white',
  GRAY = 'gray',
}

// Opciones de color disponibles
const COLOR_OPTIONS: ColorOption[] = [
  { label: 'Color del sistema', value: BlockColor.SYSTEM },
  { label: 'Blanco', value: BlockColor.WHITE },
  { label: 'Gris', value: BlockColor.GRAY },
];

const GeneralInformationQuickAccessBar = () => {
  const { watch } = useFormContext<SchemaBlockStyleType>();

  const isCarrousel = watch('isCarrousel');

  return (
    <div className="mx-10 bg-white">
      <div className="py-7">
        <TitleSection
          title={'Información General'}
          description={'Gestione el comportamiento de los enlaces en la sede electrónica'}
          asideAction={
            <div className="ml-auto">
              <InputCheckForm currentId="isCarrousel" label="Presentación tipo carrusel" />
            </div>
          }
        />
        <br />

        <div className="grid grid-cols-5 items-center gap-2">
          <InputFormContext
            className="col-span-4"
            maxLength={200}
            showLength
            title={`Título del bloque`}
            placeholder={'Ingrese el título del bloque'}
            currentId="blocktitle"
          />
          <div className="mt-3">
            <InputCheckForm currentId="showTitle" label="¿Mostrar título?" />
          </div>
        </div>

        <div className="grid grid-cols-5 items-center gap-2">
          <InputFormContext
            className="col-span-4"
            currentId="publicDescription"
            title="Descripción"
            placeholder={'Ingrese la descripción pública'}
            showLength
            maxLength={200}
          />
          <div className="mt-3">
            <InputCheckForm currentId="showDescription" label="¿Mostrar descripción?" />
          </div>
        </div>

        <div className="grid grid-cols-1 gap-4 md:grid-cols-5">
          <InputSelectContext
            className="col-span-2"
            currentId="color"
            title="Color de bloque"
            options={COLOR_OPTIONS}
            placeholder="Seleccione un color"
          />

          <InputFormContext
            title={'Número de items'}
            currentId="itemsPerView"
            type="number"
            placeholder={'Ingrese el número de items'}
            disabled={!isCarrousel}
            className={cx('col-span-2', { 'opacity-50': !isCarrousel })}
            inputProps={{ min: 1, max: 10 }}
          />
        </div>
      </div>
    </div>
  );
};

export default GeneralInformationQuickAccessBar;
